export function formatCurrency(number: number) {
  if (typeof number !== 'number') return '';
  return (number).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
};
